export default Object.freeze({
  bySiteAndDate: [],
  byDate: [],
  byCategory: [],
  byForm: [],
  loading: true,
});
